import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CreateProjectRequestModel,
  CreateProjectResponseModel,
  DeleteProjectResponseModel,
  ProjectByIdResponseModel,
  ProjectCriteriaRequestModel,
  ProjectCriteriaResponseModel,
  ProjectsRequestModel,
  ProjectsResponseModel,
  UpdateProjectRequestModel,
  UpdateProjectResponseModel,
} from '@roi/common/models/project.model';
import { Observable } from 'rxjs';
import { Endpoint } from '../constants/endpoint';
import { TransformTool } from '../tools/transform.tool';

@Injectable({ providedIn: 'root' })
export class ProjectFetch {
  private http = inject(HttpClient);
  public get(request: ProjectsRequestModel): Observable<ProjectsResponseModel> {
    return this.http.get<ProjectsResponseModel>(
      `${Endpoint.Project}/projects${TransformTool.ConvertObjectToQueryString(
        request
      )}`
    );
  }
  public getById(id: string): Observable<ProjectByIdResponseModel> {
    return this.http.get<ProjectByIdResponseModel>(
      `${Endpoint.Project}/project/${id}`
    );
  }
  public getByCriteria(
    request: ProjectCriteriaRequestModel
  ): Observable<ProjectCriteriaResponseModel> {
    return this.http.get<ProjectCriteriaResponseModel>(
      `${Endpoint.Project}/inquiry${TransformTool.ConvertObjectToQueryString(
        request
      )}`
    );
  }
  public create(
    request: CreateProjectRequestModel
  ): Observable<CreateProjectResponseModel> {
    return this.http.post<CreateProjectResponseModel>(
      `${Endpoint.Project}/create`,
      request
    );
  }
  public update(
    request: UpdateProjectRequestModel
  ): Observable<UpdateProjectResponseModel> {
    return this.http.put<UpdateProjectResponseModel>(
      `${Endpoint.Project}/update`,
      request
    );
  }
  public delete(id: number): Observable<DeleteProjectResponseModel> {
    return this.http.delete<DeleteProjectResponseModel>(
      `${Endpoint.Project}/delete/${id}`
    );
  }
}
